<template>
  <Button
    :to="to"
    :custom-size="true"
    class="signup-btn"
    :rounded="true"
    variant="secondary"
    button-style="filled"
    font-size-class="size-14"
    v-bind="decorativeAttrs"
  >
    <slot>新規会員登録</slot>
  </Button>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Button from '@/components/shared/button/Button.vue';

const props = withDefaults(
  defineProps<{
    /** 指定時は RouterLink として描画（`<a>` でラップしない） */
    to?: string;
    /** `to` 指定時のリンク説明 */
    ariaLabel?: string;
  }>(),
  {
    to: undefined,
    ariaLabel: '新規会員登録ページへ移動',
  }
);

/** ヘッダー等で親 `<a>` の装飾用に使う場合は tabindex/aria-hidden。`to` 指定時はリンクとして読み上げ可能にする */
const decorativeAttrs = computed(() =>
  props.to
    ? { 'aria-label': props.ariaLabel }
    : { tabindex: '-1', role: 'presentation', 'aria-hidden': 'true' }
);
</script>

<style scoped>
.signup-btn {
  box-sizing: border-box;
  width: 100%;
  min-height: 48px;
  padding: 12px 24px;
  min-width: 128px;
  font-size: 14px;
  line-height: 1.2;
}

@media (max-width: 430px) {
  .signup-btn {
    padding: 10px 16px;
    min-width: 0;
    font-size: 14px;
    line-height: 1.2;
  }
}

@media (max-width: 360px) {
  .signup-btn {
    padding: 9px 14px;
  }
}
</style>
